import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Card, Dropdown, Loader, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import LostSale from './lostSale';
import './lostSalesReport.scss';

class TableLostSalesReport extends Component {
  componentDidMount() {
    this.props.changeLostSalesReportDetailListPageSize(pageSizes[1].value);
  }

  onPageClick(value) {
    this.props.changeLostSalesReportDetailListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeLostSalesReportDetailListPageSize(data.value);
  }

  handleViewDetailClick(order) {
    this.props.fetchLostSalesReportDetail(order);
  }

  renderLoaderLostSalesReport() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderLostSalesReportDetail();
  }

  renderLostSalesReportDetail() {
    const {lostSalesDetail} = this.props;

    if (!lostSalesDetail.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='100%'>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return lostSalesDetail.map((element, index) => {
      return (
        <LostSale key={index} element={element} />
      );
    });
  }

  renderUserDetail(element) {
    return (
      <Popup
        inverted
        position='top center'
        content={`dealer: ${element.dealer} | agencia: ${element.agency}`}
        trigger={<span>{element.user}</span>}
      />
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems, loading} = this.props;

    if (totalItems <= pageSize || loading) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick.bind(this)}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick.bind(this)}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderIndicators() {
    const {permissions} = this.props;

    if (hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.See)) {
      return (
        <React.Fragment>
          <Table.HeaderCell textAlign='center'>ICC</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>MAD</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>SOQ</Table.HeaderCell>
        </React.Fragment>
      );
    }

    if (hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.PartialSee)) {
      return (
        <Table.HeaderCell textAlign='center'>ICC</Table.HeaderCell>
      );
    }

    return null;
  }

  renderPrices() {
    const {permissions} = this.props;
    const completeSee = hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.See);
    const partialSee = hasAccessPermission(permissions, resources.DealerLostSalesReport, scopes.PartialSee);

    if (completeSee || partialSee) {
      return (
        <React.Fragment>
          <Table.HeaderCell textAlign='center'>Precio TDE</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Precio TDE Total</Table.HeaderCell>
        </React.Fragment>
      );
    }

    return null;
  }

  render() {
    return (
      <Card fluid raised className='lost-sales-list'>
        <Table className='main-table' striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Modelos</Table.HeaderCell>
              {this.renderIndicators()}
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Precio</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Precio Total</Table.HeaderCell>
              {this.renderPrices()}
              <Table.HeaderCell textAlign='center'>Inicio Producción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Fin Producción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Disponibilidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Motivos</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderLostSalesReport()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.lostSalesReportDetail.loading,
    'lostSalesDetail': state.lostSalesReportDetail.listByPage,
    'pageNumber': state.lostSalesReportDetail.pageNumber,
    'pageSize': state.lostSalesReportDetail.pageSize,
    'totalItems': state.lostSalesReportDetail.list.length,
    'permissions': state.session.permissions,
  };
};

const {
  fetchLostSalesReportDetail,
  changeLostSalesReportDetailListPage,
  changeLostSalesReportDetailListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  fetchLostSalesReportDetail,
  changeLostSalesReportDetailListPage,
  changeLostSalesReportDetailListPageSize,
})(TableLostSalesReport);
